export const STATUS_ACTIVE = 'ACTIVE';
export const STATUS_PENDING = 'PENDING';
export const STATUS_INACTIVE = 'INACTIVE';
export const STATUS_PENDING_INVITATION = 'PENDING_INVITATION';

export const ADMIN_ROLE = 'ADMIN';
export const OPERATOR_ROLE = 'OPERATOR';
export const FINANCE_ROLE = 'FINANCE';
export const DEVELOPER_ROLE = 'DEVELOPER';
export const READ_ONLY_ROLE = 'READ_ONLY';
export const PAYMENT_CONTROLLER_ROLE = 'PAYMENT_CONTROLLER';
export const VIEW_FINANCE_ROLE = 'VIEW_FINANCE';

export const GENERAL_ADMIN_ROLE = 'GENERAL_ADMINISTRATOR';
export const USER_ROLE = 'USER';

export const USER_LANGUAGES = [
  {
    id: 'en',
    name: 'EN',
    img: 'https://resources.datanomik.com/dashboard/images/en.svg',
    locale: 'enUS',
    amount: 'en-US',
    dayjsLocale: 'en',
  },
  {
    id: 'es',
    name: 'ES',
    img: 'https://resources.datanomik.com/dashboard/images/es.svg',
    locale: 'esES',
    amount: 'es-UY',
    dayjsLocale: 'es',
  },
  {
    id: 'pt',
    name: 'PT',
    img: 'https://resources.datanomik.com/dashboard/images/pt.svg',
    locale: 'ptBR',
    amount: 'pt-BR',
    dayjsLocale: 'pt-br',
  },
];

export const INVALID_ERROR = 471;
export const BLOCKED_ERROR = 473;
export const FORBIDDEN_ERROR = 403;
export const SESSION_EXPIRED_ERROR = 401;

export const LINK_STATUS_PENDING_ASSETS = ['PENDING', 'UPDATING_ASSETS'];

export const LINK_MODE_MANUAL = 'MANUAL';
export const LINK_MODE_AUTOMATIC = 'AUTOMATIC';
